import { type Severity, type TrafficLightType } from '@scaleaq/scaleui';
import { StatusLevel } from '@scaleaq/sitecontrol-lib';

/** Scale UI tokens valid for both traffic-light-style indicators and `Alert` severity (`StatusLevel` maps only into this subset). */
export type StatusLevelIndicatorType = Extract<TrafficLightType, Severity>;

/** Maps API `StatusLevel` to Scale UI indicator tokens (`TrafficLight`, `Badge`, `Alert`, etc.). */
export const statusLevelToIndicatorType = (level: StatusLevel): StatusLevelIndicatorType => {
  switch (level) {
    case StatusLevel.Critical:
      return 'critical';
    case StatusLevel.Error:
      return 'alarm';
    case StatusLevel.Warning:
      return 'caution';
    case StatusLevel.Healthy:
      return 'success';
    default:
      return 'alarm';
  }
};
